import { GetHttp, PostHttp } from "./fetch";


const data = {

}


export async function fetchSaveOffice() {
    if ('listOffices' in data) {
        return Promise.resolve(data['listOffices']); 
    } else {
        try {
            const resolve = await GetHttp('docket/listOffices');

            if (typeof resolve === 'object' && resolve !== null && resolve[0] === 'okay' && resolve['data']) {
                data['listOffices'] = resolve['data'];
                return resolve['data'];      
            }
        } catch (error) {
            throw error;
        }

        return []
    }
}


export async function fetcSaveAdminUsers() {
    if ('adminUsers' in data) {
        return Promise.resolve(data['adminUsers']);
    }

    try {
        const resolve = await GetHttp('adminUsers/start');

        if (typeof resolve === 'object' & resolve !== null && resolve[0] == 'okay' && resolve['data']) {
            data['listOffices'] = resolve['data'];
            return resolve['data'];     
        }

    } catch (error) {
        throw error
    }

    return {};
}


export async function fetchSaveWorkers() {
    if ('workers' in data) {
        return Promise.resolve(data['workers']); 
    } else {
        try {
            const resolve = await GetHttp('adminUsers/get-workers');

            if (typeof resolve === 'object' && resolve !== null) {
                data['workers'] = resolve;
                return resolve;      
            }
        } catch (error) {
            throw error;
        }

        return {}
    }
}